import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import withReduxProvider from "shared/withReduxProvider"
import {
  isLoading,
  loadTaskReportDataAsync,
} from "reduxSlices/taskReportBuilderSlice"
import { reportExportBuilderColumnOptionShape } from "utils/propTypeShapes"
import LoadingIndicator from "shared/LoadingIndicator"
import TaskReportBuilder from "TaskReportBuilder"

const TaskReportEditor = ({
  categories,
  name,
  orderedColumns,
  reportId,
  selectedCategorySlug,
  selectedTaskFormSlug,
  shared,
  submissionColumnOptions,
  taskColumnOptions,
}) => {
  const dispatch = useDispatch()
  const loading = useSelector(isLoading)

  useEffect(() => {
    dispatch(loadTaskReportDataAsync({
      reportData: {
        categories,
        name,
        orderedColumns,
        selectedCategorySlug,
        selectedTaskFormSlug,
        shared,
        submissionColumnOptions,
        taskColumnOptions,
      },
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  return (
    loading
      ? <LoadingIndicator textValue="Loading task report ..." />
      : <TaskReportBuilder reportId={reportId} />
  )
}

TaskReportEditor.propTypes = {
  categories: types.arrayOf(types.shape({
    name: types.string.isRequired,
    slug: types.string.isRequired,
  })).isRequired,
  name: types.string.isRequired,
  orderedColumns: types.arrayOf(types.object).isRequired,
  reportId: types.number.isRequired,
  selectedCategorySlug: types.string.isRequired,
  selectedTaskFormSlug: types.string.isRequired,
  shared: types.bool.isRequired,
  submissionColumnOptions: types.arrayOf(reportExportBuilderColumnOptionShape).isRequired,
  taskColumnOptions: types.arrayOf(reportExportBuilderColumnOptionShape).isRequired,
}

export default withReduxProvider(TaskReportEditor)
